import { Stack, Typography } from '@mui/material'
import { FieldError, UseFormSetValue } from 'react-hook-form'
import { DateTimePickerField } from 'utoniq-ui'

import { CreateItemProps } from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { convertDatePickerValueToDate, dayjs } from '@/lib/dayjs'

type AppDeadlineInputCellProps = {
  setValue: UseFormSetValue<CreateItemProps>
  value: string
  error?: FieldError
}
export const AppDeadlineInputCell: Cell<AppDeadlineInputCellProps> = ({
  setValue,
  value,
  error,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  return (
    <CellFrame sx={{ pb: 7 }}>
      <Typography variant="h5">{t('appDeadlineLabel')}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ pt: 2 }}>
        {t('appDeadlineDesc')}
      </Typography>
      <Stack flex={1} sx={{ py: 2 }}>
        <DateTimePickerField
          error={error}
          onChange={date => {
            setValue(
              'metadata.merch.receptionPeriod.endedAt',
              convertDatePickerValueToDate(date) as never,
              {
                shouldValidate: true,
                shouldDirty: true,
              }
            )
          }}
          value={value ? dayjs(value) : null}
          placeholder={t('appDeadlinePlaceholder')}
          titleProps={{
            variant: 'h5',
            color: 'text.primary',
          }}
        />
      </Stack>
    </CellFrame>
  )
}
